export const SET_ACCOUNT_MODAL_SELECTED_TAB = 'ACCOUNT_MODAL/SET_SELECTED_TAB';
export const SET_ACCOUNT_MODAL_TEMPORARY_MESSAGE = 'ACCOUNT_MODAL/SET_TEMPORARY_MESSAGE';
export const SET_ACCOUNT_MODAL_EMAIL = 'account_modal/SET_EMAIL';

export const SIGN_IN_IS_LOADING = 'account_modal/sign_in/IS_LOADING';
export const SET_SIGN_IN_ERROR = 'account_modal/sign_in/SET_ERROR';

export const CREATE_USER_IS_LOADING = 'account_modal/create/IS_LOADING';
export const SET_CREATE_USER_ERROR = 'account_modal/create/SET_ERROR';
export const CREATE_USER_SUCCESS = 'account_modal/create/SUCCESS';
export const CLEAR_CREATE_USER_ERROR = 'account_modal/create/CLEAR_ERROR';

export const FORGOT_PASSWORD_IS_LOADING = 'account_modal/forgot_password/IS_LOADING';
export const SET_FORGOT_PASSWORD_ERROR = 'account_modal/forgot_password/SET_ERROR';
export const FORGOT_PASSWORD_SUCCESS = 'account_modal/forgot_password/SUCCESS';
export const CLEAR_FORGOT_PASSWORD_STATE = 'account_modal/forgot_password/CLEAR_STATE';

export const RESET_PASSWORD_IS_LOADING = 'account_modal/reset_password/IS_LOADING';
export const SET_RESET_PASSWORD_ERROR = 'account_modal/reset_password/SET_ERROR';
export const RESET_PASSWORD_SUCCESS = 'account_modal/reset_password/SUCCESS';
export const CLEAR_RESET_PASSWORD_STATE = 'account_modal/reset_password/CLEAR_STATE';
export const SET_RESET_PASSWORD_TOKEN = 'account_modal/reset_password/SET_TOKEN';
